import React from "react";
import { Loader2 } from "lucide-react";

const LoadingState = ({ label = "Loading…", className = "" }) => (
  <div
    data-testid="loading-state"
    className={`flex items-center justify-center py-16 text-muted-foreground gap-2 ${className}`}
  >
    <Loader2 className="h-4 w-4 animate-spin" />
    <span className="text-sm">{label}</span>
  </div>
);

export default LoadingState;
